var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReferFriend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 138.388,
    height: 111.998,
    viewBox: "0 0 138.388 111.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_679",
    "data-name": "Ellipse 679",
    cx: 32.808,
    cy: 32.808,
    r: 32.808,
    transform: "translate(46.397 92.794) rotate(-135)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85415",
    "data-name": "Path 85415",
    d: "M475.709,844.031c1.426,2.955,4.745,9.828,6.627,10.413.461-.2,3.531-2.049,7.872-17.24a7.55,7.55,0,0,1,4.771-4.489c.415-.274.889-.543,1.388-.809a3.586,3.586,0,0,0-.288,2.474c.721,2.693,4.853,3.925,9.229,2.753s7.338-4.306,6.616-7a3.855,3.855,0,0,0-2.108-2.375,24.07,24.07,0,0,1,4.665-.27,26.248,26.248,0,0,1,4.378.568c15.038,2.862,26.977,13.738,33.624,24.461,4.127,6.657-4.939,5.407-7.316,1.946-6.915-10.069-14.3-15.327-26.289-16.438,1.936,5.161,4.278,12.087,6.532,20.5.871,3.25-23.506,9.782-24.377,6.532a221.573,221.573,0,0,1-4.728-21.843c-4.014,12.659-8.084,18.335-13.339,18.786q-.341.03-.672.03c-6.3,0-10.069-7.8-13.4-14.708C468.5,846.505,475.3,843.181,475.709,844.031Z",
    transform: "translate(-468.875 -827.463)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55569",
    "data-name": "Group 55569",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55556",
    "data-name": "Group 55556",
    transform: "translate(45.594 19.204)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_676",
    "data-name": "Ellipse 676",
    cx: 32.808,
    cy: 32.808,
    r: 32.808,
    transform: "translate(13.589 13.589)",
    fill: "#738a9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85396",
    "data-name": "Path 85396",
    d: "M1216.295,839.874c1.749-3.082,2.686-5.766-2.827-8.772s-7.616-2.86-10,.993-3.785,7.428,2.383,10.653S1213.629,844.571,1216.295,839.874Z",
    transform: "translate(-1196.644 -798.91)",
    fill: "#808fa0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_55551",
    "data-name": "Group 55551",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55550",
    "data-name": "Group 55550",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85397",
    "data-name": "Path 85397",
    d: "M478.971,702.809c7.426,0,16.3-4.168,23.389-6.067,6.25-1.675,19.544-2.681,15.635-12.422l-8.63-.518c-3.452-12.355-5.155-25.248-7.251-37.879-2.159-13.012-2.907-28.649-13.038-38.391,1.242-4.894-3.339-13.384-4.822-17.68a27.4,27.4,0,0,1,12.108,6.294c4.6,4.032,7.939,12.882,15.291,12.183,15.788-1.5-6.968-23.255-11.65-26.614l0,0c-7.232-5.245-16.033-9.124-25.056-9.5,1.4-12.624-5.011-30.643-20.983-25.627-7.388,2.32-7.66,6.948-8.411,13.505-.885,7.731-4.383,16.361,5.615,19.366-5.11,4-5.266,12.523-8.336,18.065-2.983-4.581-3.176-7.985-5.244-8.9-.876-3.991-.629-5.25-1.332-6.8-3.731-8.22-13.91,2.59-9.608,11.866-2.325,4.734,7.28,16.179,11.272,18.151,7.934,3.919,14.575-2.522,17.95-9.306.762,3.522,1.108,9.961,3.534,12.762-4.06,13.9,3.8,28.384,8.561,41.106,4.342,11.594,9.065,23.235,12.149,35.243L472.9,696.4C473.327,699.558,475.449,702.809,478.971,702.809Z",
    transform: "translate(-416.113 -545.412)",
    fill: "#7d8ea0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_55549",
    "data-name": "Group 55549",
    transform: "translate(13.369 3.657)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55539",
    "data-name": "Group 55539",
    transform: "translate(32.002 55.821)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x2: 1.306,
    y2: 4.875,
    transform: "translate(26.499 81.988)",
    fill: "none",
    stroke: "#ffc984",
    strokeMiterlimit: 10,
    strokeWidth: 48
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    x2: 1.306,
    y2: 4.875,
    transform: "translate(38.688 78.722)",
    fill: "none",
    stroke: "#ffc984",
    strokeMiterlimit: 10,
    strokeWidth: 48
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_55537",
    "data-name": "Group 55537",
    transform: "translate(35.916 81.726)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85398",
    "data-name": "Path 85398",
    d: "M461.065,1885.611l-5.485,1.47c-1.123,1.08-.844,3.339.414,6.421l15.235-4.082a2.524,2.524,0,0,0,1.784-3.091Z",
    transform: "translate(-454.875 -1885.611)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85399",
    "data-name": "Path 85399",
    d: "M515.983,1887.722c-6.314,1.692-6.071-.986-7.357-.641l5.485-1.47,6.384.383A18.924,18.924,0,0,1,515.983,1887.722Z",
    transform: "translate(-507.921 -1885.611)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_85400",
    "data-name": "Path 85400",
    d: "M552.711,1141.812c-14.027-37.335,24.778-47.771,31.69-8.491,2.643,15.023,6.756,42.279,9.45,52.334l-8.815,3.668-16.872-58.184a1.286,1.286,0,0,0-1.568-.886h0a1.286,1.286,0,0,0-.915,1.551l14.48,58.825-9.468,1.231C568.081,1182.11,557.584,1154.783,552.711,1141.812Z",
    transform: "translate(-549.679 -1108.403)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_55538",
    "data-name": "Group 55538",
    transform: "translate(15.052 84.828)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85401",
    "data-name": "Path 85401",
    d: "M662.322,1916.586l5.485-1.47c1.513.374,2.4,2.47,2.852,5.768l-15.235,4.082a2.524,2.524,0,0,1-3.091-1.784Z",
    transform: "translate(-652.332 -1915.116)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85402",
    "data-name": "Path 85402",
    d: "M684.224,1919.35c6.314-1.692,4.764-3.889,6.05-4.234l-5.485,1.47-5.337,3.524A18.93,18.93,0,0,0,684.224,1919.35Z",
    transform: "translate(-674.799 -1915.116)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_85403",
    "data-name": "Path 85403",
    d: "M1059.305,919.245",
    transform: "translate(-1034.331 -882.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_55540",
    "data-name": "Group 55540",
    transform: "translate(0 31.482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85404",
    "data-name": "Path 85404",
    d: "M1013.94,906.3q.331,0,.672-.03c5.77-.5,10.113-7.29,14.521-22.718.575-2.01-.51-7.181-2.508-6.569a7.55,7.55,0,0,0-4.771,4.489c-4.341,15.192-7.411,17.043-7.872,17.241-1.883-.584-5.2-7.458-6.627-10.413-.41-.85-7.212,2.474-6.818,3.291C1003.871,898.5,1007.636,906.3,1013.94,906.3Z",
    transform: "translate(-1000.52 -876.931)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_85405",
    "data-name": "Path 85405",
    d: "M755.727,827.489c-5.31-.319-15.061,2.294-19.5,5.225,0,0,.828,12.842,6.054,32.343.871,3.25,25.248-3.282,24.377-6.532C761.43,839.024,755.727,827.489,755.727,827.489Z",
    transform: "translate(-710.12 -801.183)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85406",
    "data-name": "Path 85406",
    d: "M873,839.655c-4.375,1.172-8.507-.06-9.229-2.753a3.587,3.587,0,0,1,.288-2.474,44.993,44.993,0,0,1,13.448-4.146,3.855,3.855,0,0,1,2.108,2.375C880.336,835.349,877.374,838.482,873,839.655Z",
    transform: "translate(-836.565 -803.706)",
    fill: "#5a677f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_55544",
    "data-name": "Group 55544",
    transform: "translate(17.653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85407",
    "data-name": "Path 85407",
    d: "M890.031,840.516c-3.366.9-6.533,0-7.074-2.024a2.828,2.828,0,0,1,.456-2.26,47.544,47.544,0,0,1,9.749-2.945,3.041,3.041,0,0,1,1.983,1.939C895.686,837.246,893.4,839.614,890.031,840.516Z",
    transform: "translate(-871.74 -806.395)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85408",
    "data-name": "Path 85408",
    d: "M883.307,577.542c-5.575,0-10.726,4.52-10.726,10.095,0,3.785-3.235,12.39-.631,15.142,3.9,4.125,18.811,4.125,22.713,0,2.6-2.752-.631-11.357-.631-15.142C894.033,582.062,888.882,577.542,883.307,577.542Z",
    transform: "translate(-870.937 -577.542)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_55541",
    "data-name": "Group 55541",
    transform: "translate(13.393 17.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85409",
    "data-name": "Path 85409",
    d: "M913.5,758.516l-2.123-7.922a2.524,2.524,0,0,1,4.875-1.306l2.123,7.922C918.736,758.556,913.861,759.863,913.5,758.516Z",
    transform: "translate(-911.291 -747.417)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_55542",
    "data-name": "Group 55542",
    transform: "translate(2.907 3.788)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18100",
    "data-name": "Rectangle 18100",
    width: 16.404,
    height: 21.451,
    rx: 8.202,
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_677",
    "data-name": "Ellipse 677",
    cx: 2.524,
    cy: 3.785,
    rx: 2.524,
    ry: 3.785,
    transform: "translate(13.632 5.047)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_55543",
    "data-name": "Group 55543",
    transform: "translate(1.443)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85410",
    "data-name": "Path 85410",
    d: "M994.456,582.589c0,1.94-.844,6.308-5.677,6.308-.553-3.627-.789-11.355,10.725-11.355Z",
    transform: "translate(-988.576 -577.542)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85411",
    "data-name": "Path 85411",
    d: "M952.71,625.542c0,1.94-1.973,6.308,8.832,6.308l-.093-6.308Z",
    transform: "translate(-946.828 -620.495)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_678",
    "data-name": "Ellipse 678",
    cx: 6.309,
    cy: 3.155,
    rx: 6.309,
    ry: 3.155,
    transform: "translate(6.061 0.633)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18101",
    "data-name": "Rectangle 18101",
    width: 3.786,
    height: 6.307,
    transform: "translate(16.156 6.311)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85412",
    "data-name": "Path 85412",
    d: "M908.361,733.256a17.862,17.862,0,0,1-3.786,1.056V721.542h3.786Z",
    transform: "translate(-887.158 -706.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85413",
    "data-name": "Path 85413",
    d: "M918.458,673.542h0a1.893,1.893,0,0,0-1.893,1.893v5.678h0a3.785,3.785,0,0,0,3.785-3.785v-1.893A1.893,1.893,0,0,0,918.458,673.542Z",
    transform: "translate(-900.408 -663.447)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_55545",
    "data-name": "Group 55545",
    transform: "translate(44.732 26.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85414",
    "data-name": "Path 85414",
    d: "M507.752,852.743c-6.648-10.723-18.587-21.6-33.624-24.461a26.243,26.243,0,0,0-4.378-.568c-2.689.782,1.488,10.3,3.572,10.454,12.488.941,20.039,6.219,27.113,16.52C502.812,858.15,511.879,859.4,507.752,852.743Z",
    transform: "translate(-468.875 -827.714)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_55548",
    "data-name": "Group 55548",
    transform: "translate(0 26.28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55547",
    "data-name": "Group 55547",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55546",
    "data-name": "Group 55546",
    transform: "translate(-12.821 -28.76)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    x1: 42.828,
    y1: 42.828,
    transform: "translate(42.828)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 18
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    x1: 42.828,
    y1: 42.828,
    transform: "translate(37.474 5.354)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 18
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    x1: 42.828,
    y1: 42.828,
    transform: "translate(32.121 10.707)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 18
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    x1: 42.828,
    y1: 42.828,
    transform: "translate(26.767 16.061)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 18
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    x1: 42.828,
    y1: 42.828,
    transform: "translate(21.414 21.414)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 18
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    x1: 42.828,
    y1: 42.828,
    transform: "translate(16.06 26.768)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 18
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    x1: 42.828,
    y1: 42.828,
    transform: "translate(10.707 32.121)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 18
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    x1: 42.828,
    y1: 42.828,
    transform: "translate(5.353 37.475)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 18
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    x1: 42.828,
    y1: 42.828,
    transform: "translate(0 42.828)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 18
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_55555",
    "data-name": "Group 55555",
    transform: "translate(31.022 3.657)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85416",
    "data-name": "Path 85416",
    d: "M890.031,840.516c-3.366.9-6.533,0-7.074-2.024a2.828,2.828,0,0,1,.456-2.26,47.544,47.544,0,0,1,9.749-2.945,3.041,3.041,0,0,1,1.983,1.939C895.686,837.246,893.4,839.614,890.031,840.516Z",
    transform: "translate(-871.74 -806.395)",
    fill: "#d2d6dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85417",
    "data-name": "Path 85417",
    d: "M883.307,577.542c-5.575,0-10.726,4.52-10.726,10.095,0,3.785-3.235,12.39-.631,15.142,3.9,4.125,18.811,4.125,22.713,0,2.6-2.752-.631-11.357-.631-15.142C894.033,582.062,888.882,577.542,883.307,577.542Z",
    transform: "translate(-870.937 -577.542)",
    fill: "#8e97a5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_55552",
    "data-name": "Group 55552",
    transform: "translate(13.393 17.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85418",
    "data-name": "Path 85418",
    d: "M913.5,758.516l-2.123-7.922a2.524,2.524,0,0,1,4.875-1.306l2.123,7.922C918.736,758.556,913.861,759.863,913.5,758.516Z",
    transform: "translate(-911.291 -747.417)",
    fill: "#bdc3cb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_55553",
    "data-name": "Group 55553",
    transform: "translate(2.907 3.788)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18102",
    "data-name": "Rectangle 18102",
    width: 16.404,
    height: 21.451,
    rx: 8.202,
    transform: "translate(0)",
    fill: "#bdc3cb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_55564",
    "data-name": "Group 55564"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55562",
    "data-name": "Group 55562",
    transform: "translate(43.637 27.836)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55557",
    "data-name": "Group 55557",
    transform: "translate(2.394 6.551)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87902",
    "data-name": "Path 87902",
    d: "M2.524,0A2.524,2.524,0,1,1,0,2.524,2.524,2.524,0,0,1,2.524,0Z",
    transform: "matrix(-0.126, -0.992, 0.992, -0.126, 0.638, 5.645)",
    fill: "#808fa0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_55558",
    "data-name": "Group 55558",
    transform: "translate(12.313 17.575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85423",
    "data-name": "Path 85423",
    d: "M1200.676,791.992l4.371,2.524-6.94,12.021a1.262,1.262,0,0,1-1.724.462l-2.186-1.262a1.262,1.262,0,0,1-.462-1.724Z",
    transform: "translate(-1193.567 -791.992)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_55559",
    "data-name": "Group 55559",
    transform: "translate(12.528 10.68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85424",
    "data-name": "Path 85424",
    d: "M1145.559,735.164l8.742,5.047a5.047,5.047,0,0,0,6.895-1.847h0a5.047,5.047,0,0,0-1.848-6.895l-8.742-5.047Z",
    transform: "translate(-1145.559 -726.422)",
    fill: "#808fa0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_55560",
    "data-name": "Group 55560",
    transform: "translate(1.262 1.262)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85425",
    "data-name": "Path 85425",
    d: "M1252.706,654.338l11.266.676,5.047-8.742-6.219-9.418Z",
    transform: "translate(-1252.706 -636.853)",
    fill: "#808fa0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_55561",
    "data-name": "Group 55561"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85426",
    "data-name": "Path 85426",
    d: "M1300.473,644.69a1.262,1.262,0,0,0,1.724-.462l10.095-17.484a1.262,1.262,0,1,0-2.185-1.262l-10.095,17.484A1.262,1.262,0,0,0,1300.473,644.69Z",
    transform: "translate(-1299.842 -624.851)",
    fill: "#808fa0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_55563",
    "data-name": "Group 55563"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85427",
    "data-name": "Path 85427",
    d: "M1454.763,741.814l.32-.321.538.091c1.481.252,2.94.6,4.408.9,1.308.326,2.62.633,3.92.995q1.51-1.281,3.09-2.487c1.193-.917,2.425-1.794,3.72-2.6-.9,1.235-1.861,2.4-2.861,3.525s-2.018,2.231-3.076,3.294l-.32.321-.536-.091c-1.481-.252-2.941-.594-4.408-.9-1.308-.326-2.62-.631-3.919-.992q-1.511,1.281-3.092,2.487c-1.194.918-2.427,1.794-3.725,2.6.9-1.236,1.861-2.4,2.862-3.528S1453.7,742.877,1454.763,741.814Z",
    transform: "translate(-1430.17 -698.62)",
    fill: "#777d8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85428",
    "data-name": "Path 85428",
    d: "M1346.835,421.754l-.629-.563.165-1.166a52.942,52.942,0,0,1,1.775-7.984c-.662-.9-1.3-1.818-1.9-2.78-.405-.647-.776-1.326-1.141-2.011a20.057,20.057,0,0,1-.987-2.154,20.042,20.042,0,0,1,2.077,1.14c.657.413,1.307.832,1.923,1.283a43.359,43.359,0,0,1,3.53,2.86l.63.565-.166,1.169a52.838,52.838,0,0,1-1.785,7.985c.662.9,1.3,1.818,1.9,2.779.4.647.776,1.325,1.142,2.008a20.256,20.256,0,0,1,.99,2.15,20.345,20.345,0,0,1-2.073-1.141c-.655-.414-1.305-.832-1.922-1.283A43.663,43.663,0,0,1,1346.835,421.754Z",
    transform: "translate(-1302.759 -400.369)",
    fill: "#777d8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85429",
    "data-name": "Path 85429",
    d: "M1476.5,383.684a38.12,38.12,0,0,1,4.043,5.583,38.13,38.13,0,0,1-6.394-2.576,63.229,63.229,0,0,1-5.807-3.326l-.592-.38-.412-1.14a76.605,76.605,0,0,1-3.286-12.151c-1.3-1.266-2.561-2.573-3.756-3.968a37.7,37.7,0,0,1-4.039-5.594,37.715,37.715,0,0,1,6.4,2.572,62.778,62.778,0,0,1,5.809,3.331l.594.382.412,1.143a76.519,76.519,0,0,1,3.271,12.158C1474.037,380.983,1475.3,382.29,1476.5,383.684Z",
    transform: "translate(-1440.73 -360.132)",
    fill: "#777d8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85430",
    "data-name": "Path 85430",
    d: "M1582.929,606.143c1.521-.68,3.064-1.268,4.624-1.792l.715-.24.894.569a63.1,63.1,0,0,1,7.3,5.443c1.282-.18,2.571-.33,3.877-.412.83-.055,1.671-.066,2.514-.07a23.675,23.675,0,0,1,2.563.131,23.721,23.721,0,0,1-2.209,1.306c-.748.388-1.5.768-2.259,1.1-1.52.679-3.062,1.269-4.62,1.793l-.712.24-.892-.568a63.3,63.3,0,0,1-7.306-5.433c-1.282.18-2.572.331-3.878.411-.83.056-1.672.066-2.515.068a23.367,23.367,0,0,1-2.565-.136,23.4,23.4,0,0,1,2.21-1.309C1581.417,606.86,1582.167,606.479,1582.929,606.143Z",
    transform: "translate(-1578.458 -578.456)",
    fill: "#777d8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85431",
    "data-name": "Path 85431",
    d: "M1671.217,449.119a28.461,28.461,0,0,1,3.412-1.049c1.145-.288,2.294-.536,3.45-.732l.645-.11.34.678a57.546,57.546,0,0,1,2.521,5.857c.923-.049,1.848-.076,2.778-.071a28.7,28.7,0,0,1,3.561.205,28.715,28.715,0,0,1-3.41,1.047c-1.144.288-2.293.537-3.448.733l-.643.109-.339-.676a57.793,57.793,0,0,1-2.525-5.853c-.923.049-1.848.076-2.778.07A28.458,28.458,0,0,1,1671.217,449.119Z",
    transform: "translate(-1670.719 -438.071)",
    fill: "#777d8d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_55568",
    "data-name": "Group 55568",
    transform: "translate(53.244 51.714)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55565",
    "data-name": "Group 55565"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85432",
    "data-name": "Path 85432",
    d: "M1235.874,859.677c1.22-2.112,1.708-4.113-.706-5.507l-2.914-1.682c-2.414-1.394-3.9.03-5.122,2.142s-1.708,4.113.706,5.507l2.914,1.682C1233.165,863.213,1234.654,861.789,1235.874,859.677Z",
    transform: "translate(-1226.121 -851.932)",
    fill: "#bdc3cb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_55567",
    "data-name": "Group 55567",
    transform: "translate(5.72 13.857)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55566",
    "data-name": "Group 55566"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85433",
    "data-name": "Path 85433",
    d: "M1129.665,1001.853q.331,0,.672-.03c5.77-.5-.17-7.755-.63-7.557-1.883-.584-5.2-7.458-6.627-10.413-.41-.85-7.213,2.474-6.818,3.291C1119.6,994.053,1123.361,1001.853,1129.665,1001.853Z",
    transform: "translate(-1116.245 -983.716)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_85434",
    "data-name": "Path 85434",
    d: "M1134.085,1106.6a.952.952,0,0,0,0-1.338h0a.952.952,0,0,0-1.338,0h0a.94.94,0,0,0,0,1.338h0a.914.914,0,0,0,.668.278h0A.935.935,0,0,0,1134.085,1106.6Z",
    transform: "translate(-1113.748 -1078.38)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85435",
    "data-name": "Path 85435",
    d: "M1184.977,1055.681a.941.941,0,0,0,0-1.338h0a.941.941,0,0,0-1.338,0h0a.952.952,0,0,0,0,1.338h0a.952.952,0,0,0,.669.277h0A.941.941,0,0,0,1184.977,1055.681Z",
    transform: "translate(-1169.996 -1032.809)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85436",
    "data-name": "Path 85436",
    d: "M1235.9,1004.781a.952.952,0,0,0,0-1.338h0a.952.952,0,0,0-1.338,0h0a.941.941,0,0,0,0,1.338h0a.916.916,0,0,0,.668.278h0A.939.939,0,0,0,1235.9,1004.781Z",
    transform: "translate(-1226.272 -987.266)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferFriend);
export default __webpack_public_path__ + "static/media/referFriend.e0ce248549cd3a99aecf5d94bc1d0cae.svg";
export { ForwardRef as ReactComponent };